import { render, staticRenderFns } from "./SyllabusTeachingEffectsModal.vue?vue&type=template&id=0d0728f2&"
import script from "./SyllabusTeachingEffectsModal.vue?vue&type=script&lang=js&"
export * from "./SyllabusTeachingEffectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports